import dayjs from 'dayjs';
import { PhoneNumber } from './phone-number.js';
import { DataModel } from '../dto/data-model.js';
import { ComponentList } from '../../components/core/component-list.js';
import { IEntity } from '../../components/core/entity.js';
import { Component } from '../../components/core/component.js';

export abstract class CustomerAccountBase extends DataModel implements IEntity {
  abstract get uniqueId(): string;
  abstract get creationDate(): dayjs.Dayjs | null;
  abstract get firstName(): string;
  abstract get lastName(): string;
  abstract get formattedName(): string;
  abstract get email(): string;
  abstract get phoneNumber(): PhoneNumber | null;
  abstract get components(): ComponentList;

  abstract hasComponentByTypeId(typeId: string): boolean;
  abstract mustFindComponentByTypeId<C extends Component>(typeId: string): C;
  abstract findComponentByTypeId<C extends Component>(typeId: string): C | null;
  abstract findComponentByInstanceId<C extends Component>(instanceId: string): C | null;
  abstract findComponentsByTypeId<C extends Component>(typeId: string): C[];
  abstract addComponent<C extends Component>(component: C): void;
  abstract addComponents(list: Component[]): void;
  abstract removeComponentByTypeId(typeId: string): boolean;
  abstract removeComponentByInstanceId(instanceId: string): boolean;
  abstract removeComponentAt(index: number): void;
  abstract removeAllComponents(): void;
  abstract popAllComponentsByTypeId<C extends Component>(typeId: string): C[];
  abstract popComponentByTypeId<C extends Component>(typeId: string): C | null;
  abstract popComponent<C extends Component>(component: C): C | null;
  abstract replaceComponent<C extends Component>(replacement: C): boolean;
  abstract addOrReplaceComponent<C extends Component>(component: C): void;
  abstract mustFindComponentField<C extends Component, F>(componentTypeId: string, find: (c: C) => F): F;
  abstract findComponentField<C extends Component, F>(componentTypeId: string, find: (c: C) => F): F | null;
}
